<template>
  <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-text-center">
    <h2 class="question-title-v2 tw-mb-6">
      {{ question.title }}
    </h2>

    <!-- Doctor card (populated when `otherrecords` includes "doctor") -->
    <div
      v-if="doctor"
      class="tw-mb-6 tw-flex tw-items-center tw-gap-4"
    >
      <img
        v-if="doctor.profileUrl"
        :src="doctor.profileUrl"
        :alt="doctorName"
        class="tw-h-20 tw-w-20 tw-rounded-full tw-object-cover"
      >
      <div
        v-else
        class="tw-flex tw-h-20 tw-w-20 tw-items-center tw-justify-center tw-rounded-full tw-bg-lavender-purple tw-text-xl tw-font-atten-bold tw-text-white"
      >
        {{ doctorInitial }}
      </div>
      <p class="tw-mb-0 tw-text-onyx">
        Dr. {{ doctorName }}
      </p>
    </div>

    <!-- Experience rating. Gated on the BE `showrating` flag. -->
    <FollowupV7Rating
      v-if="showRating"
      v-model="selectedRating"
      class="tw-mb-6"
    />

    <button
      type="button"
      class="tw-mt-2 tw-rounded-lg tw-bg-lavender-purple tw-px-12 tw-py-3 tw-font-atten-bold tw-uppercase tw-tracking-widest tw-text-white disabled:tw-opacity-60"
      :disabled="disabled"
      @click="submitAnswer"
    >
      Continue
    </button>
  </div>
</template>

<script>
import { AnalyticsService } from '@/services/analytics.service';

import FollowupV7Rating from '@/components/followup/v7/rating.vue';

/**
 * Renders an `answertype: 'nothing'` exit / success screen.
 * Shows the doctor record (from `question.doctor`) and, when the BE opts in
 * via `question.showrating`, a standalone NPS rating submitted to analytics.
 */
export default {
  name: 'FollowupV7Exit',

  components: {
    FollowupV7Rating,
  },

  props: {
    question: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedRating: null,
    };
  },

  computed: {
    doctor() {
      return this.question.doctor || null;
    },
    doctorName() {
      if (!this.doctor) return '';
      return `${this.doctor.firstname || ''} ${this.doctor.lastname || ''}`.trim();
    },
    doctorInitial() {
      return (this.doctor && this.doctor.firstname
        ? this.doctor.firstname.charAt(0)
        : 'W'
      ).toUpperCase();
    },
    showRating() {
      return this.question.showrating === true;
    },
  },

  methods: {
    submitAnswer() {
      if (this.selectedRating) {
        AnalyticsService.submitNPSSurveyResponse(this.selectedRating);
      }
      this.$emit('submitAnswer', this.question.id, '');
    },
  },
};
</script>
